// import React from 'react';

// export default function About(){
//   return (
//     <section id="about" className="py-16">
//       <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-8 items-center">
//         <div>
//           <h2 className="text-3xl font-bold">About Our Laboratory</h2>
//           <p className="mt-4 text-gray-600">We are dedicated to providing expert pathology services with a focus on accuracy, speed, and patient care. Our state-of-the-art laboratory is equipped with the latest technology and staffed by highly trained professionals.</p>
//         </div>
//         <div className="flex justify-center">
//           <div className="w-56 h-56 bg-red-100 rounded-lg flex items-center justify-center text-red-700 text-6xl">🧪</div>
//         </div>
//       </div>
//     </section>
//   );
// }


// import React from "react";
// import labImg from "../assets/lab-about.png"; // तुझा lab image add करा

// export default function About() {
//   return (
//     <section id="about" className="py-20 bg-gray-50">
//       <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
        
//         {/* Text Content */}
//         <div className="space-y-6">
//           <h2 className="text-4xl font-bold text-red-600">
//             About Our Laboratory
//           </h2>
//           <p className="text-gray-700 text-lg leading-relaxed">
//             We are dedicated to providing expert pathology services with a focus on 
//             <span className="font-semibold text-red-600"> accuracy</span>, 
//             <span className="font-semibold text-red-600"> speed</span>, and 
//             <span className="font-semibold text-red-600"> patient care</span>. 
//             Our state-of-the-art laboratory is equipped with the latest technology and staffed by highly trained professionals.
//           </p>
//         </div>

//         {/* Image / Icon */}
//         <div className="flex justify-center relative">
//           <div className="w-full max-w-md rounded-xl overflow-hidden shadow-xl transform hover:scale-105 transition-transform duration-500">
//             <img 
//               src={labImg} 
//               alt="Laboratory" 
//               className="w-full h-72 object-cover"
//             />
//           </div>
//         </div>

//       </div>
//     </section>
//   );
// }



// import React, { useState, useEffect } from "react";
// import labImg1 from "../assets/lab-about.png"; // पहिली image
// import labImg2 from "../assets/anni.jpg"; // दुसरी image

// export default function About() {
//   const [flipped, setFlipped] = useState(false);

//   // Auto flip every 3 सेकंद
//   useEffect(() => {
//     const timer = setInterval(() => setFlipped(prev => !prev), 3000);
//     return () => clearInterval(timer);
//   }, []);

//   return (
//     <section id="about" className="py-20 bg-gray-50">
//       <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
        
//         {/* Text Content */}
//         <div className="space-y-6">
//           <h2 className="text-4xl font-bold text-red-600">
//             About Our Laboratory
//           </h2>
//           <p className="text-gray-700 text-lg leading-relaxed">
//             We are dedicated to providing expert pathology services with a focus on 
//             <span className="font-semibold text-red-600"> accuracy</span>, 
//             <span className="font-semibold text-red-600"> speed</span>, and 
//             <span className="font-semibold text-red-600"> patient care</span>. 
//             Our state-of-the-art laboratory is equipped with the latest technology and staffed by highly trained professionals.
//           </p>
//         </div>

//         {/* Image Flip */}
//         <div className="flex justify-center relative perspective">
//           <div className={`relative w-full max-w-md h-72 transform-style preserve-3d transition-transform duration-700 ${flipped ? "rotate-y-180" : ""}`}>
            
//             {/* Front Image */}
//             <div className="absolute w-full h-full backface-hidden rounded-xl overflow-hidden shadow-xl">
//               <img 
//                 src={labImg1} 
//                 alt="Laboratory Front" 
//                 className="w-full h-full object-cover"
//               />
//             </div>

//             {/* Back Image */}
//             <div className="absolute w-full h-full backface-hidden rotate-y-180 rounded-xl overflow-hidden shadow-xl">
//               <img 
//                 src={labImg2} 
//                 alt="Laboratory Back" 
//                 className="w-full h-full object-cover"
//               />
//             </div>

//           </div>
//         </div>

//       </div>
//     </section>
//   );
// }





// import React, { useState, useEffect } from "react";
// import labImg1 from "../assets/lab-about.png"; // पहिली image
// import labImg2 from "../assets/anni.jpg"; // दुसरी image

// export default function About() {
//   const [flipped, setFlipped] = useState(false);

//   // Auto flip every 3 seconds
//   useEffect(() => {
//     const timer = setInterval(() => setFlipped(prev => !prev), 3000);
//     return () => clearInterval(timer);
//   }, []);

//   return (
//     <section id="about" className="py-20 bg-gray-50">
//       <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">

//         {/* Text Content */}
//         <div className="space-y-6">
//           <h2 className="text-4xl font-bold text-red-600">
//             About Our Laboratory
//           </h2>
//           <p className="text-gray-700 text-lg leading-relaxed">
//             We are dedicated to providing expert pathology services with a focus on 
//             <span className="font-semibold text-red-600"> accuracy</span>, 
//             <span className="font-semibold text-red-600"> speed</span>, and 
//             <span className="font-semibold text-red-600"> patient care</span>. 
//             Our state-of-the-art laboratory is equipped with the latest technology and staffed by highly trained professionals.
//           </p>
//         </div>

//         {/* Image Flip Card */}
//         <div className="flex justify-center perspective">
//           <div
//             className={`relative w-full max-w-md h-72 transition-transform duration-700 transform-style preserve-3d ${flipped ? "rotate-y-180" : ""}`}
//           >
//             {/* Front Image */}
//             <div className="absolute w-full h-full backface-hidden rounded-xl overflow-hidden shadow-xl">
//               <img
//                 src={labImg1}
//                 alt="Laboratory Front"
//                 className="w-full h-full object-cover"
//               />
//             </div>

//             {/* Back Image */}
//             <div className="absolute w-full h-full backface-hidden rotate-y-180 rounded-xl overflow-hidden shadow-xl">
//               <img
//                 src={labImg2}
//                 alt="Laboratory Back"
//                 className="w-full h-full object-cover"
//               />
//             </div>
//           </div>
//         </div>

//       </div>
//     </section>
//   );
// }




import React, { useState, useEffect } from "react";
import labImg1 from "../assets/lab-about.png"; // Front image
import labImg2 from "../assets/years2.png";      // Back image

export default function About() {
  const [flipped, setFlipped] = useState(false);

  // Auto flip every 3 seconds
  useEffect(() => {
    const timer = setInterval(() => setFlipped(prev => !prev), 3000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">

        {/* Text Content */}
        <div className="space-y-6">
          <h2 className="text-4xl font-bold text-red-600">
            About Our Laboratory
          </h2>
          <p className="text-gray-700 text-lg leading-relaxed">
            We are dedicated to providing expert pathology services with a focus on 
            <span className="font-semibold text-red-600"> accuracy</span>, 
            <span className="font-semibold text-red-600"> speed</span>, and 
            <span className="font-semibold text-red-600"> patient care</span>. 
            Our state-of-the-art laboratory is equipped with the latest technology and staffed by highly trained professionals.
          </p>
        </div>

        {/* Image Flip Card */}
        <div className="flex justify-center perspective">
          <div className={`about-flip-container`}>
            <div className={`about-flip-inner ${flipped ? "flipped" : ""}`}>

              {/* Front Image */}
              <div className="about-flip-front">
                <img
                  src={labImg1}
                  alt="Laboratory Front"
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Back Image */}
              <div className="about-flip-back">
                <img
                  src={labImg2}
                  alt="Laboratory Back"
                  className="w-full h-full object-cover"
                />
              </div>

            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
